module.exports = __webpack_public_path__ + "static/project-4-1-dc3141694923f8e7323e6b4c894cd0a7.jpg";